export const suggested_action ={
    'Scrap_at_IKEA':"Scrap at IKEA",
    'Scrap_by_ESP':"Scrap by ESP",
    'Repair_at_IKEA':"Repair at IKEA",
    'Scrap_by_supplier':"Scrap by Supplier",
    'Return':"Return",
    'Replace':"Replace"
}
export const Status_lable={
    'open':'Open',
    'AI':'With Units',
    'AP':'Approved',
    'RJ':'Rejected',
    'buyes_claim':'Buyers claim',
    'closed':'Closed'

}
export const status_class={
    'open':'label-info',
    'AI':'label-warning',
    'AP':'label-info',
    'RJ':'label-danger',
    'buyes_claim':'label-info',
    'closed':'label-info'
}